module.exports = __webpack_public_path__ + "img/ryzs4.3a0f302f.jpg";